$(document).ready(function() {
  selectOptionText()
})

function selectOptionText() {
  $('input[type=radio]').change(function() {
    prosesSelectOptionText($(this))
  })
}

window.selectOptionText = selectOptionText;
window.updateLabelSelectOption = ($ulTargetRadio) => {
  var data_model           = $ulTargetRadio.attr('data-model')
  var target_select_option = $ulTargetRadio.attr('data-target-select-option')
  $(`#${target_select_option}`).text(`Select ${data_model}`)
  $(`#${target_select_option}`).val('')
}

window.prosesSelectOptionText = ($radio) => {
  var radio_id             = $radio.attr('id');
  var parent_select_option = $radio.closest('.parentSelectOption');
  var target_select_option = parent_select_option.attr('data-target-select-option');
  var label_text           = $(`label[for='${radio_id}']`).find('span').text();

  $(`#${target_select_option}`).html(label_text);
  $(`#${target_select_option}`).val(label_text)
}

document.querySelectorAll('.list-select-option').forEach(el => {
  el.addEventListener('click', e => {
    const val = e.currentTarget.getAttribute('data-value')
    const parent = e.currentTarget.closest('.popup-wrapper')
    const input = document.querySelector(`[data-select-target=${parent.getAttribute('id')}]`)
    // input.value = val
    // input.dispatchEvent(new Event('change'))
    parent.classList.remove('show')
    window.postProcessClosePopup(parent)
  })
})
